export function formatDateTime(value: string | null): string {
  return value === null ? "—" : new Date(value).toLocaleString("ru-RU");
}
